import { config } from 'state/product/config'

/* <li><img alt="{{ product.alt_text }} in {{ product.colormap }}" data-original="https://static.marketreach.io/EB/swatch/{{ product.id }}_{{ product.color_id }}.jpg" src="https://static.marketreach.io/EB/swatch/{{ product.id }}_{{ product.color_id }}.jpg" data-label="new"></li> */

export const createSwatch = (product, color) => {
  let swatch = document.createElement('img')
  swatch.alt = `${product.name} in ${color.colormap}`
  swatch.className = 'active lazy'
  // swatch.src = color.url.swatch // config.pixel
  swatch.src = config.pixel

  swatch.setAttribute('data-original', `${color.url.swatch}`)
  return swatch
}
